import { DatePipe, Location } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener, Renderer2, ViewChild, AfterViewInit } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { addAppointmentRequest, serviceAppointmentTimeSlotModel, ProviderModel, appointmentReasonModel, appointmentTimeSlotModel, reschedulePatientAppointModel, scheduleAppointmentModel } from 'src/app/models/appointment/appointment';
import { LocationModel } from 'src/app/models/login/login';
import { AppointmentService } from 'src/app/services/appointment.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
declare var $: any;
@Component({
  selector: 'app-standalonescheduler',
  templateUrl: './standalonescheduler.component.html',
  styleUrls: ['./standalonescheduler.component.css']
})

export class StandAloneSchedulerComponent implements OnInit {
  patientpersonalinfo: any;
  selectedProvider: any;
  selectedLocation: any;
  selectedReason: any;
  appointmentReasonData: any;
  minDate: any;
  appointmentForm: FormGroup = new FormGroup({});
  currentTimeZoneOffSet: any;
  appointmentSlots: any[] = [];
  selectedSlot: any;
  appointmentType: any = 'office';
  providerList: any[] = [];
  locationList: any[] = [];
  reasonList: any[] = [];
  selectedDateApp: any;
  isFirstAvailibleButton: boolean = true;
  minDateFull: string = "";
  isFirstAvailable: boolean = true;
  searchResultFlag = false;
  appointmentDate: Date | string = '';
  appointmentFirstDate: Date | string = '';
  firstAvailabeSelectedDate = "";
  dSeriesFinal: any;
  firstAvailableIstrue: boolean = false;
  count: any;
  appOBJ: any;
  selectedMonthName = '';
  hardwareError: boolean = false;
  isAgree: boolean = false;
  isWaitlist: boolean = false;
  selectedYear: number = new Date().getFullYear();
  selectedMonth: Date = new Date()
  providerData: ProviderModel[] = [];
  dSeriesFinalFirstAndLast: any;
  public groupedSlots: { [key: string]: any[] } = {};
  public groupedSlotsWaitlist: { [key: string]: any[] } = {};
  expandedSlots: { [key: string]: boolean } = {};
  selectedAppointmentTimeSlot: appointmentTimeSlotModel;
  addAppointmentRequest: addAppointmentRequest = new addAppointmentRequest();
  scheduleAppointmentModel: scheduleAppointmentModel[] = [];
  Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
  ShowSlotsScreens: boolean = false
  isSkipPayment: boolean = false;
  appointment_type: any = 'office';
  landFromCheckin: any = '';
  first_Name: any;
  last_Name: any;
  cell_phone: any;
  Practice_code: any;
  date_Of_Birth: any;
  isDirectUrlMode = false;
  isMonthChanged = false;
  isdateUnselect = false;
  appointmentSlotsLoaded: boolean = false;
  provider: any;
  Location: any;
  reason: any;
  result: any;
  appointmenttype: any = 'office';
  availableDate: any;
  availableSlot: any;
  selectedTime: any;
  selectedMonthCalander: any;
  selectedYearCalander: any;
  isFirstAvailableChk: any;
  groupedSlotsArray: any[] = [];
  waitlistSlotsArray: any[] = [];
  selectedDayNumbers: number[] = [];
  selectedAllLocation = 'all';
  isLargeScreen: boolean;
  isShortScreen: boolean;
  providerLocation: any;
  appointmentTimeSlotFlag: boolean = false;
  isRtl: boolean = false;
  isFromCancel: boolean = false;
  isFromNewPatient: boolean = false;
  patientpersonalinfoCheckin: any;
  showOnlyMorningSlots: boolean = false;
  showOnlyEveningSlots: boolean = false;
  isDrsite: boolean = true;
  is100Prac: boolean = false;
  backButtonProviderCode: boolean = false;
  minimumDate: Date;
  //waseem changes
  isFromAuth: boolean = false;
  encounterId: any;
  landfrom: any;
  /////////////////
  dayNames: any = [
    { "id": "0", "Day": "Sun" },
    { "id": "1", "Day": "Mon" },
    { "id": "2", "Day": "Tue" },
    { "id": "3", "Day": "Wed" },
    { "id": "4", "Day": "Thu" },
    { "id": "5", "Day": "Fri" },
    { "id": "6", "Day": "Sat" }
  ]
  monthNames: any = [
    { "id": "1", "Month": "January" },
    { "id": "2", "Month": "February" },
    { "id": "3", "Month": "Mar" },
    { "id": "4", "Month": "April" },
    { "id": "5", "Month": "May" },
    { "id": "6", "Month": "June" },
    { "id": "7", "Month": "July" },
    { "id": "8", "Month": "August" },
    { "id": "9", "Month": "September" },
    { "id": "10", "Month": "October" },
    { "id": "11", "Month": "November" },
    { "id": "12", "Month": "December" }
  ];
  dropdownSettingsProviderMulti: IDropdownSettings
    = {
      singleSelection: false,
      idField: 'providerCode',
      textField: 'providerName',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      selectAllText: 'Select All Providers',
      unSelectAllText: 'UnSelect All Providers',
      //defaultOpen: false
    };
  dropdownSettingsProvider: IDropdownSettings
    = {
      singleSelection: true,
      idField: 'providerCode',
      textField: 'providerName',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      selectAllText: 'Select All Providers',
      unSelectAllText: 'UnSelect All Providers',
      //defaultOpen: false
    };

  constructor(private renderer: Renderer2, private translateService: TranslateService, private spinner: NgxSpinnerService, private datePipe: DatePipe, private _phrutilService: PhrutillsService, private appoint: AppointmentService, private datepipe: DatePipe, private _registor: RegistorpatientService
    , private _router: Router, private location: Location, private cdr: ChangeDetectorRef, private _route: ActivatedRoute) {
    if (this.landFromCheckin == 'new_patient') {
      this.isFromNewPatient = true;
    }
    this.selectedSlot = new serviceAppointmentTimeSlotModel();
    this.minDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth > 576) {
      this.isLargeScreen = true;
      this.isShortScreen = false;
    }
    else {
      this.isShortScreen = true;
      this.isLargeScreen = false;
    }
  }
  getCurrentTimeZone() {
    let currDate = new Date().toString();
    let getOffsetwithTime = currDate.split('(');
    let offSet = getOffsetwithTime[0].substr(getOffsetwithTime[0].length - 9);
    this.currentTimeZoneOffSet = offSet.trim();
    if (this.currentTimeZoneOffSet.includes('+')) {
      let RemoveAlpht = this.currentTimeZoneOffSet.split('+');
      this.currentTimeZoneOffSet = '+' + RemoveAlpht[1];
    }
    else if (this.currentTimeZoneOffSet.includes('-')) {
      let RemoveAlpht = this.currentTimeZoneOffSet.split('-');
      this.currentTimeZoneOffSet = '-' + RemoveAlpht[1];
    } localStorage.setItem('currentTimeZoneOffSet', this.currentTimeZoneOffSet);
  }
  buildappointmentForm() {
    this.appointmentForm = new FormGroup({
      provider: new FormControl('', Validators.required),
      appointmenttype: new FormControl('office', Validators.required),
      location: new FormControl('', Validators.required),
      reason: new FormControl('', Validators.required),
    });
  }
  async ngOnInit(): Promise<void> {
    localStorage.setItem('appointment_type', 'office');
    if (this.is100Prac)
    this.filterWellVisit('office');
    this.minimumDate = new Date();
    this.buildappointmentForm();
    this.onResize({ target: window })
    //console.log("Selected Month on init:", this.selectedMonth);
    this.updateMonthDisplay(this.selectedMonth);
    const params = await firstValueFrom(this._route.queryParams);
    try {
      //console.log("query params in scheduler", params);
      //console.log("selectedProvider", this.selectedProvider);
      //console.log("backButtonProviderCode", this.backButtonProviderCode);
      if (params['practice_code'] != null) {
        localStorage.clear();
        try {
          let prac = params['practice_code'];
          localStorage.setItem('appointment_type', 'office');
          this.is100Prac = Number(prac) == 100 ? true : false;
          if (params['practice_code'] != null && params['practice_code'] == 100) {
            this.Practice_code = 100;
          }
          if (params['encid'] != null && params['lf'] != null && params['lf'] == 'checkoutnotes') {
            //localStorage.clear();
            this.landfrom = params['lf'];
            this.encounterId = params['encid'];
            this.isDrsite = false;
            localStorage.setItem("landFrom", params['lf']);
            this.isFirstAvailable = true;
            this.minimumDate = this.patientpersonalinfo?.recallDate ? new Date(this.patientpersonalinfo.recallDate) : new Date();
            //console.log("first available", this.isFirstAvailable);
          }
          await this.VerifyPractice(params['practice_code']);
        } catch (err) {
        }
      }
      if (params['from'] != null && params['from'] == 'auth') {
        this.isFromAuth = true;
      } else {
        this.isFromAuth = false;
      }
      if (params['lf'] != null && params['lf'] == 'drsite') {
        //localStorage.clear();
        localStorage.setItem("landFrom", params['lf']);
      }
      else {
        //console.log("landFromCheckin", params['lf']);
        localStorage.setItem("landFrom", params['lf']);
        this.isDrsite = false;
      }

      this.selectedTime = params['selectedSlot'];
      this.availableDate = params['availableDate'];
      this.isFirstAvailableChk = params['isFirstAvailable'];
    } catch (err) {
    }
    try {
      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
      ////console.log('Decrypted Patient Info:', this.patientpersonalinfo);
      this.Practice_code = this.patientpersonalinfo.practice_Code;
      if (this.patientpersonalinfo.practice_Code == 100) {
        this.is100Prac = true;
      }
      this.first_Name = this.patientpersonalinfo.first_Name
      this.appointment_type = this.appointmenttype || localStorage.getItem('appointment_type') || '';
      const selectedValuesFromStorage = localStorage.getItem('selectedValues');
      const SelectedValues = selectedValuesFromStorage ? JSON.parse(selectedValuesFromStorage) : {};
      const providerValue = this.selectedProvider || localStorage.getItem('selectedProvider') || '';
      const locationValue = this.Location || SelectedValues.locationValue || '';
      const reasonValue = this.reason || SelectedValues.reasonValue || '';
      ////console.log('Initial ProviderValue', providerValue.providerCode, 'Location value', locationValue, 'Reason Value', reasonValue, "appointmentTypeValue", this.appointment_type);
      this.appointmentForm.patchValue({
        provider: providerValue,
        appointmenttype: this.appointment_type || 'office',
        location: locationValue,
        reason: reasonValue
      });

      if (this.appointment_type == null || this.appointment_type == '') {
        this.appointment_type = 'office';
        this.appointmentForm.patchValue({ appointmenttype: this.appointment_type });
      }
      this.setCurrentMonth();
      if (this.landfrom == "checkoutnotes" && this.patientpersonalinfo.recallDate) {
        //console.log("recallDate", this.patientpersonalinfo.recallDate);
        this.setAppointmentDates(this.patientpersonalinfo.recallDate);
      } else {
        this.setAppointmentDates(new Date());
      }
      this.getCurrentTimeZone();
      this.providerList = await this.getProviders();
      this.locationList = await this.getLocation();
      this.reasonList = await this.getAppointmentReason();

      if (locationValue) {
        this.selectedLocation = {
          locationCode: locationValue,
          locationName: this.getLocationName(locationValue)
        };
      }

      if (reasonValue) {
        //console.log("reasonValue", reasonValue);
        this.selectedReason = {
          reasonId: reasonValue,
          reasonName: this.getReasonName(reasonValue)
        };
      }
      this.minDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.minDateFull = this.minDate ?? "";
      this.selectedDateApp = this.minDateFull;
      if (this.landfrom == "checkoutnotes" && this.patientpersonalinfo.recallDate && params['availableDate']) {
        //console.log("availableDate", this.availableDate);
        //const availableDateObj = new Date(this.availableDate);
        //this.updateMonthDisplay(availableDateObj);
        //console.log("First Available Check:", this.isFirstAvailableChk);
        //console.log("first available :", this.isFirstAvailable);
        this.appointmentDate = this.availableDate;
        this.selectedDateApp = this.availableDate;
        this.isFirstAvailable = this.isFirstAvailableChk === 'true';
        this.selectedSlot = this.selectedTime ? this.selectedTime.replace(/"/g, '').trim() : null;
        this.appointmentSlotsLoaded = false;
        this.appointmentForm.get('reason')
        //this.backButtonProviderCode = true;
        //await this.searchAvailable(true);
        this.updateCarouselDates(this.availableDate instanceof Date ? this.datepipe.transform(this.availableDate, 'MM/dd/yyyy') || '' : this.availableDate);
        this.appointmentSlotsLoaded = true;
        this.appointmentDate = this.availableDate;

        if (this.selectedSlot && Array.isArray(this.appointmentSlots)) {
          this.markSelectedSlot(this.selectedSlot);
        }

        this.ShowSlotsScreens = true;
        this.appointmentTimeSlotFlag = true;

      }
      if (this.availableDate && !this.patientpersonalinfo.recallDate) {
        const availableDateObj = new Date(localStorage.getItem('dSeriesFinal'));
        this.updateMonthDisplay(availableDateObj);
        this.appointmentDate = this.availableDate;
        this.selectedDateApp = this.availableDate;
        this.isFirstAvailable = this.isFirstAvailableChk === 'true';;
        this.selectedSlot = this.selectedTime ? this.selectedTime.replace(/"/g, '').trim() : null;
        this.appointmentSlotsLoaded = false;
        this.appointmentForm.get('reason')
        this.backButtonProviderCode = true;
        //console.log("getAppointmentTimeSlot ngOninit");
        await this.getAppointmentTimeSlot();
        this.updateCarouselDates(this.availableDate instanceof Date ? this.datepipe.transform(this.availableDate, 'MM/dd/yyyy') || '' : this.availableDate);
        this.appointmentSlotsLoaded = true;
        this.appointmentDate = this.availableDate;

        if (this.selectedSlot && Array.isArray(this.appointmentSlots)) {
          this.markSelectedSlot(this.selectedSlot);
        }

        this.ShowSlotsScreens = true;
        this.appointmentTimeSlotFlag = true;
      }
      this.expandedSlots = {};

    } catch (error) {
      //console.error("Error during ngOnInit:", error);
    }
    if (this.landFromCheckin === 'checkin_reschedule') {
      this._phrutilService.patientlanguage$.subscribe(language => {
        if (language === 'es') {
          this.isRtl = false;
          this._phrutilService.setTitle('Reprogramar una cita');
        } else if (language === 'hi') {
          this.isRtl = false;
          this._phrutilService.setTitle('अपॉइंटमेंट पुनः निर्धारित करें');
        } else if (language === 'ur') {
          this.isRtl = true;
          this._phrutilService.setTitle('اپوائنٹمنٹ دوبارہ شیڈول کریں');
        }
        else if (language === 'gu') {
          this.isRtl = false;
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ ફરીથી શેડ્યૂલ કરો');
        } else {
          this.isRtl = false;
          this._phrutilService.setTitle('Reschedule Appointment');
        }
      });
    } else {
      this._phrutilService.patientlanguage$.subscribe(language => {
        if (language === 'es') {
          this.isRtl = false;
          this._phrutilService.setTitle('Reservar una cita');
        } else if (language === 'hi') {
          this.isRtl = false;
          this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
        } else if (language === 'ur') {
          this.isRtl = true;
          this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
        } else if (language === 'gu') {
          this.isRtl = false;
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
        } else {
          this.isRtl = false;
          this._phrutilService.setTitle('Book an Appointment');
        }
      });
    }
    this.appointmentForm.valueChanges.subscribe(() => {
    });
  }
  selectAppointmenttype(type: any) {
    if (this.is100Prac)
    this.filterWellVisit(type);
    if (type == 'office') {
      this.appointment_type = 'office';
    }
    if (type == 'telehealth') {
      this.appointment_type = 'telehealth';
    }
    localStorage.setItem('appointment_type', this.appointment_type);
    if (this.appointmentForm.get('provider')?.value.length > 0 && this.appointmentForm.get('appointmenttype')?.value.length > 0 && this.appointmentForm.get('location')?.value.length > 0
      && this.appointmentForm.get('reason')?.value.length > 0) {
     // console.log("appointment type changed, fetching slots");
      this.getAppointmentTimeSlot();
    }
  }

  async VerifyEncounter(prac_code: any, encId: any): Promise<void> {
    this.spinner.show();
    try {
      const res: any = await this._registor.Verifyencounter(prac_code, encId).toPromise();

      this.spinner.hide();

      if (res.data && res.statusCode == 200) {
        ////console.log(res);
        this.patientpersonalinfo.provider_code = res.data.provideR_CODE;
        this.patientpersonalinfo.reasonid = res.data.reasonId;
        // this.patientpersonalinfo.reasonid = '92814160';
        this.patientpersonalinfo.recallDate = res.data.recall_Date;
        // this.patientpersonalinfo.recallDate = '11/24/2025';
        let data = this._phrutilService.encrypt(this.patientpersonalinfo);
        localStorage.setItem('PatientInfo', data);
        let data1 = this._phrutilService.decrypt(data);
        // ////console.log('decrypt pinfo', data1);
      } else {
        $("#isNotValid_linkexiting").modal("show");
        throw new Error('Invalid practice code');
      }
    } catch (error) {
      this.spinner.hide();
      $("#isNotValid_linkexiting").modal("show");
      throw error;
    }
  }

  markSelectedSlot(selectedTime: string): void {
    if (!selectedTime || !this.appointmentSlots?.length) return;
    selectedTime = selectedTime.replace(/"/g, '').trim();
    //console.log('Cleaned groupedSlotsArray:', this.groupedSlotsArray);
    for (const group of this.groupedSlotsArray) {
      //console.log('Checking group with date:', group.date);
      //console.log('Current appointmentDate:', this.appointmentDate);
      if (group.date === this.appointmentDate) {
        //console.log('Searching in group for date:', group.date);

        for (const provider of group.providers) {
          //console.log('Checking provider:', provider.providerName);

          for (const slot of provider.slots) {
            //console.log('Comparing slot:', slot);

            if (slot.availableSlot === selectedTime && slot.availableDate === this.appointmentDate) {
              this.selectedSlot = slot;
              //console.log('Matched slot:', slot);
              return;
            }
          }
        }
      }
    }
    console.warn('No matching slot found for the selected time and date.');
  }
  async searchAvailable(isFirstAvail: boolean) {
    //console.log("searchAvailable called with isFirstAvail:", this.selectedDateApp);
    //console.log("searchAvailable called with isFirstAvail firstAvailabeSelectedDate:", this.firstAvailabeSelectedDate);
    this.scheduleAppointmentModel = [];
    this.isFirstAvailable = isFirstAvail;
    this.appointmentTimeSlotFlag = true;
    this.searchResultFlag = false;
    this.selectedSlot = null;
    if (isFirstAvail) {
      this.groupedSlotsArray = [];
      this.appointmentSlots = [];
      this.Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      this.groupedSlots = {};
      this.isFirstAvailibleButton = true;
      if (this.isMonthChanged) {
        // this.dSeriesFinal = [];
        // let date = new Date(this.selectedYearCalander, this.selectedMonthCalander - 1, 1);
        // let count = 0;
        // while (count < 5) {
        //   const day = date.getDay();

        //   if (day !== 0 && day !== 6) {
        //     const dateDigit = this.firstAvailabeSelectedDate;
        //     const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
        //       m.id == (date.getMonth() + 1).toString())?.Month || '';

        //     this.dSeriesFinal.push({
        //       fullDate: `${date.getMonth() + 1}/${dateDigit}/${date.getFullYear()}`,
        //       date: dateDigit,
        //       day: this.dayNames.find((x: any) => Number(x.id) === day)?.Day || 'Unknown',
        //       month: monthName,
        //       isDisable: false,
        //       isSelected: false
        //     });
        //     count++;
        //   }
        //   date.setDate(date.getDate() + 1);
        // }
        //this.updateCarouselDates(this.dSeriesFinal[0].fullDate);
        //////console.log('firstAvailable selected date on month change:', this.firstAvailabeSelectedDate);
        this.updateCarouselDates(this.firstAvailabeSelectedDate);
        //this.appointmentDate = this.dSeriesFinal[0].fullDate;
        this.appointmentDate = this.firstAvailabeSelectedDate;
      }
      else {
        if (!this.isdateUnselect) {
          this.appointmentDate = this.selectedDateApp;
        }
        else {
          this.appointmentDate = this.firstAvailabeSelectedDate
        }
      }
      this.getAppointmentTimeSlot().then(() => {
      });
    }
    else if (!isFirstAvail) {
      const validDates = this.dSeriesFinal.map((dateObj: any) =>
        this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
      );
      const filteredSlots = this.firstAvailabeSelectedDate ? validDates.includes(this.datepipe.transform(new Date(this.firstAvailabeSelectedDate), 'MM/dd/yyyy')) : '';
      //////console.log('Non-first available selected date:', this.firstAvailabeSelectedDate, 'Filtered Slots:', filteredSlots);
      if (this.firstAvailabeSelectedDate && filteredSlots) {
        this.isFirstAvailibleButton = false;
        this.appointmentDate = this.firstAvailabeSelectedDate
        this.isFirstAvailable = false;
        this.firstAvailableIstrue = false;
        this.scheduleAppointmentModel = [];
        let allSlots: any[] = [];
        let foundAtLeastOneSlot = false;
        this.spinner.show('timeslots');
        //for (let provider of this.backButtonProviderCode ? this.selectedProvider : this.selectedProvider.providerCode) {
        for (let provider of this.selectedProvider) {
          const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
          Obj_AppointmentTimeSlotModel.providerCode = provider.providerCode//this.appointmentForm.get('provider')?.value;
          Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
          Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
          Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
          Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
          Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
          Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
          Obj_AppointmentTimeSlotModel.date = this.appointmentDate;
          const check = await this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel);
          if (check) {
            const slots = this.appointmentSlots;
            if (Array.isArray(slots) && slots.length > 0) {
              slots.forEach((slot: any) => {
                slot.providerName = provider.providerName;
                slot.providerCode = provider.providerCode;
              });
              allSlots.push(...slots);
              foundAtLeastOneSlot = true;
            }
          }
        }
        if (foundAtLeastOneSlot && allSlots.length > 0) {
          this.groupedSlots = this.groupSlotsByDate(allSlots);
          this.updateGroupedSlotsArray();
          this.appointmentSlots = allSlots;
          this.appointmentTimeSlotFlag = true;
          this.updateGroupedSlotsArray();
          this.ShowSlotsScreens = true;
        } else {
          this.appointmentTimeSlotFlag = false;
          this.ShowSlotsScreens = true;
        }
        this.spinner.hide('timeslots');
      }
      else {
        this.isFirstAvailibleButton = false;
        this.appointmentDate = '';
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
          dateObj.isSelected = false;
          return dateObj;
        });
        this.getAppointmentTimeSlot().then(() => {
          this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
            ...dateObj,
            isSelected: false
          }));
          this.cdr.detectChanges();
        });
      }
      this.cdr.detectChanges();
    }

  }
  async SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel: any) {
    //console.log('Searching first available slots with model:', Obj_AppointmentTimeSlotModel);
    //console.log("isFirstAvailable in SearchFirstAvailableSlot", this.isFirstAvailable);
    try {
      this.appointmentSlots = [];
      const res: any = await this.appoint.getAppointmentTimeSlotsBreeze(Obj_AppointmentTimeSlotModel);
      if (res.data.appointmentSlots && res.data.appointmentSlots.length > 0) {
        this.ShowSlotsScreens = true
        this.appointmentTimeSlotFlag = true;
        this.appointmentSlots = res.data.appointmentSlots;
        if (this.isFirstAvailable && this.appointmentSlots.length > 0) {
          let normalizedDate = this.ConverttoLocalDate(this.appointmentSlots[0].availableDate);
          this.appointmentFirstDate = this.datepipe.transform(normalizedDate, 'MM/dd/yyyy');
        }
        return true;
      } else {
        this.appointmentTimeSlotFlag = this.scheduleAppointmentModel.length > 0;
        this.firstAvailableIstrue = false;
        return false;
      }
    } catch (error) {
      this.appointmentTimeSlotFlag = this.scheduleAppointmentModel.length > 0;
      this.firstAvailableIstrue = false;
      let text;
      this.translateService.get('Appointment.appointmentSlots.no_slots').subscribe((translation: string) => {
        text = translation;
        this._phrutilService.showWarning(text);
      });
      this.spinner.hide('timeslots');
      return false;
    }
  }
  async getAppointmentTimeSlot() {
    //////console.log('Fetching appointment slots with form values:', this.appointmentForm.value);
    //console.log("firstAvailable in getAppointmentTimeSlot", this.isFirstAvailable);
    this.appointmentForm.markAllAsTouched();
    if (this.appointmentForm.get('provider')?.value.length > 0 && this.appointmentForm.get('appointmenttype')?.value.length > 0 && this.appointmentForm.get('location')?.value.length > 0
      && this.appointmentForm.get('reason')?.value.length > 0) {
     // console.log('Fetching appointment slots with form values:', this.appointmentForm.value);
      if (this.currentTimeZoneOffSet.length <= 0) {
        this._phrutilService.showInfo("Please set your TimeZone first", "");
        this.appointmentTimeSlotFlag = false;
        return;
      }
      if (new Date(this.appointmentDate) < new Date(this.datepipe.transform(this.minDateFull, 'MM/dd/yyyy') ?? "")) {
        this._phrutilService.showInfo("Previous date appointments can't be scheduled.", "");
        return;
      }
      ////console.log('Getting appointment slots for date:', this.appointmentDate);
      this.searchResultFlag = true;
      this.appointmentSlotsLoaded = true
      this.appointmentTimeSlotFlag = true;
      this.scheduleAppointmentModel = [];
      this.Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      if (this.isFirstAvailable) {
        if (!this.appointmentDate || this.appointmentDate === '') {
          this.appointmentDate = this.datepipe.transform(new Date(), "MM/dd/yyyy") ?? "";
        }
      }
      if (!this.isFirstAvailable) {
        ////console.log('Not first available selected date before setting appointment dates:', this.appointmentDate);
        if (this.selectedDateApp == null || this.selectedDateApp == undefined || this.selectedDateApp == '') {
          this.selectedDateApp = this.minDateFull;
        }
        const transformedDate = this.datepipe.transform(this.selectedDateApp, "MM/dd/yyyy");
        ////console.log('Transformed selected date:', transformedDate);
        if (transformedDate) {
          this.setAppointmentDates(this.backButtonProviderCode ? new Date(localStorage.getItem('dSeriesFinal')) : new Date(transformedDate));
        } else {
        }
      }
      else
        ////console.log('First available selected date before setting appointment dates:', this.appointmentDate);
        if (!this.isFirstAvailable && this.dSeriesFinal[0].fullDate > this.appointmentDate) {
          let dummYCheck: boolean = true;
          for (let i = 0; i < 5; i++) {
            if (this.appointmentDate === this.dSeriesFinal[i]) {
              dummYCheck = false;
            }
          }
          ////console.log('Dummy Check for first available date selection:', dummYCheck);
          if (dummYCheck) {
            this.setAppointmentDates(this.backButtonProviderCode ? new Date(localStorage.getItem('dSeriesFinal')) : new Date(this.appointmentDate));
          }
        }
      const selectedValues = {
        providerValue: this.appointmentForm.value.provider,
        locationValue: this.appointmentForm.value.location,
        reasonValue: this.appointmentForm.value.reason
      };
      // //console.log("Storing selected values:", selectedValues);
      localStorage.setItem('selectedValues', JSON.stringify(selectedValues));
      this.count = 0;
      this.spinner.show('timeslots');
      let allSlots: any[] = [];
      let foundAtLeastOneSlot = false;
      const obj: any = new serviceAppointmentTimeSlotModel();
      obj.date = this.appointmentDate;
      //console.log('provider codes to search:', this.selectedProvider);

      // ////console.log('backButtonProviderCode:', this.backButtonProviderCode);
      // let providerList = [];

      // if (this.backButtonProviderCode) {
      //   providerList = [{ providerCode: this.backButtonProviderCode, providerName: this.getProviderName(this.backButtonProviderCode) }];
      // } else if (Array.isArray(this.selectedProvider.providerCode)) {
      //   providerList = this.selectedProvider.providerCode;
      // }
      // ////console.log('Final provider list for searching slots:', providerList);
      //////console.log('Final selectedProvider for searching slots:', this.backButtonProviderCode);
      //for (let provider of this.backButtonProviderCode ? this.selectedProvider : this.selectedProvider.providerCode) {
      //console.log('Searching slots for provider:', this.selectedProvider );
      for (let provider of this.selectedProvider) {
       // console.log('Searching slots for provider:', provider);
        obj.providerCode = provider.providerCode;
        obj.locationCode = this.appointmentForm.get('location')?.value;
        obj.practiceCode = this.Practice_code;
        obj.patientAccount = localStorage.getItem('patientAccount');
        obj.reasonID = this.appointmentForm.get('reason')?.value;
        obj.patientTimeZone = this.currentTimeZoneOffSet;
        obj.isFirstAvailable = this.isFirstAvailable;
        obj.isTelehealth = this.appointment_type == 'office' ? false : true;
        this.result = provider.providerName;
        //console.log('obj values', obj);
        if (this.isFirstAvailable) {
          //console.log('Searching first available slots for provider');
          const check = await this.SearchFirstAvailableSlot(obj);
          if (check) {
            const slots = this.appointmentSlots;
            if (Array.isArray(slots) && slots.length > 0) {
              slots.forEach((slot: any) => {
                slot.providerName = provider.providerName;
                slot.providerCode = provider.providerCode;
              });
              allSlots.push(...slots);
              foundAtLeastOneSlot = true;
            }
          }
        }
        else {
          //console.log("searching all records")
          obj.startDate = this.appointmentDate;

          // let month, day, year;
          // if (typeof this.appointmentDate === 'string') {
          //   [month, day, year] = this.appointmentDate.split('/').map(Number);
          // } else if (this.appointmentDate instanceof Date) {
          //   month = this.appointmentDate.getMonth() + 1;
          //   day = this.appointmentDate.getDate();
          //   year = this.appointmentDate.getFullYear();
          // }

          // let currentDate = new Date(year, month - 1, day);
          // currentDate.setDate(currentDate.getDate() + 1);
          // ////console.log('Initial currentDate for endDate calculation:', this.datepipe.transform(currentDate, 'MM/dd/yyyy'));

          // let weekdaysAdded = 0;
          // while (weekdaysAdded <= 5) {
          //   weekdaysAdded++;
          //   if (weekdaysAdded <= 5) {
          //     currentDate.setDate(currentDate.getDate() + 1);
          //     //console.log('Adding weekday:', this.datepipe.transform(currentDate, 'MM/dd/yyyy'));
          //   }
          //   //console.log('Intermediate date after adding weekday:', this.datepipe.transform(currentDate, 'MM/dd/yyyy'));
          //   ////console.log('Weekdays added so far:', weekdaysAdded);
          // }

          // obj.endDate = this.datepipe.transform(currentDate, 'MM/dd/yyyy');
          if (this.dSeriesFinal && this.dSeriesFinal.length > 0) {

            const lastDateObj = this.dSeriesFinal[this.dSeriesFinal.length - 1];

            obj.endDate = lastDateObj.fullDate;

            //console.log('✅ End Date from dSeriesFinal:', obj.endDate);

          }
          obj.date = this.appointmentDate;
         // console.log(obj, "date range obj");
          //if (this.isFromAuth) {
          //  return ;
          //}
          try {
            const res: any = await this.appoint.getAppointmentTimeSlotsDateRangeBreeze(obj);
            if (res.statusCode === 200) {
              const slots = res.data.appointmentSlots;
              ////console.log('Slots received for provider', provider.providerCode, ':', slots);
              if (Array.isArray(slots) && slots.length > 0) {
                ////console.log('Processing slots for provider:', provider.providerCode);
                slots.forEach((slot: any) => {
                  slot.providerName = provider.providerName;
                  slot.providerCode = provider.providerCode;
                });
                allSlots.push(...slots);
                foundAtLeastOneSlot = true;
              }
            }
          } catch (err) {
            //console.error("Error for provider:", provider.providerCode, err);
          }
        }
      }
      if (foundAtLeastOneSlot && allSlots.length > 0) {
        ////console.log('All aggregated slots:', allSlots);
        this.groupedSlots = this.groupSlotsByDate(allSlots);
        this.updateGroupedSlotsArray();
        this.appointmentSlots = allSlots;
        this.appointmentTimeSlotFlag = true;
        //this.updateGroupedSlotsArray();
        this.ShowSlotsScreens = true;
      } else {
        this.appointmentTimeSlotFlag = false;
        this.ShowSlotsScreens = true;
      }
      this.spinner.hide('timeslots');
    }
  }

  async onAppointmentDate(selectedDate: any) {
    //console.log('Selected date:', selectedDate);
    if (selectedDate.isDisable) {
      this._phrutilService.showInfo("Previous date appointments can't be scheduled.", "");
      return;
    }
    if (new Date(this.datepipe.transform(selectedDate.fullDate, 'MM/dd/yyyy')) < new Date(this.datepipe.transform(this.minDateFull, 'MM/dd/yyyy') ?? "")) {
      this._phrutilService.showInfo("Previous date appointments can't be scheduled.", "");
      return;
    }
    if (this.appointment_type == '' || this.appointment_type == null) {
      this.appointment_type = 'office';
    }
    if (this.appointmentForm.get('provider')?.value.length == 0) {
      return;
    }
    this.firstAvailabeSelectedDate = selectedDate.fullDate;

    if (this.appointmentDate == selectedDate.fullDate) {
      this.isdateUnselect = false;
      if (selectedDate.fullDate == this.dSeriesFinal[0].fullDate) {
        if (this.dSeriesFinal[0].isSelected) {
          this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
            dateObj.isSelected = false;
            return dateObj;
          });
          this.appointmentDate = '';
          this.selectedDateApp = null;
          this.selectedSlot = null;
          this.appointmentDate = selectedDate.fullDate;
          this.selectedDateApp = selectedDate.fullDate;
          this.getAppointmentTimeSlot().then(() => {
            this.cdr.detectChanges();
          });
          return;
        }
        this.appointmentDate = selectedDate.fullDate;
        this.isFirstAvailable = false;
        this.firstAvailableIstrue = false;
        this.scheduleAppointmentModel = [];
        this.selectedSlot = null;
        this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
          ...item,
          isSelected: item.fullDate === selectedDate.fullDate
        }));
        let allSlots: any[] = [];
        let foundAtLeastOneSlot = false;

        this.spinner.show('timeslots');
        //for (let provider of this.backButtonProviderCode ? this.selectedProvider : this.selectedProvider.providerCode) {
        for (let provider of this.selectedProvider) {
          const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
          Obj_AppointmentTimeSlotModel.providerCode = provider.providerCode;//this.appointmentForm.get('provider')?.value;
          Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
          Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
          Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
          Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
          Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
          Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
          Obj_AppointmentTimeSlotModel.date = this.appointmentDate;
          Obj_AppointmentTimeSlotModel.isTelehealth = this.appointment_type == 'office' ? false : true;
          const check = await this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel);
          if (check) {
            const slots = this.appointmentSlots;
            if (Array.isArray(slots) && slots.length > 0) {
              slots.forEach((slot: any) => {
                slot.providerName = provider.providerName;
                slot.providerCode = provider.providerCode;
              });
              allSlots.push(...slots);
              foundAtLeastOneSlot = true;
            }
          }
        }
        if (foundAtLeastOneSlot && allSlots.length > 0) {
          this.groupedSlots = this.groupSlotsByDate(allSlots);
          this.updateGroupedSlotsArray();
          this.appointmentSlots = allSlots;
          this.appointmentTimeSlotFlag = true;
          this.updateGroupedSlotsArray();
          this.ShowSlotsScreens = true;
        } else {
          this.appointmentTimeSlotFlag = false;
          this.ShowSlotsScreens = true;
        }
      }
      else {
        this.selectedDateApp = this.dSeriesFinal[0].fullDate;
        this.isFirstAvailibleButton = false;
        this.firstAvailabeSelectedDate = ''
        this.appointmentDate = this.dSeriesFinal[0].fullDate;
        this.selectedSlot = null;
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
          dateObj.isSelected = false;
          return dateObj;
        });
        this.getAppointmentTimeSlot().then(() => {
          this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
            ...dateObj,
            isSelected: false
          }));
          this.cdr.detectChanges();
        });
      }
    }
    else {
      this.isdateUnselect = true;
      this.appointmentDate = selectedDate.fullDate;
      this.isFirstAvailable = false;
      this.firstAvailableIstrue = false;
      this.scheduleAppointmentModel = [];
      this.selectedSlot = null;
      this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
        ...item,
        isSelected: item.fullDate === selectedDate.fullDate
      }));
      let allSlots: any[] = [];
      let foundAtLeastOneSlot = false;
      this.spinner.show('timeslots');
      //for (let provider of this.backButtonProviderCode ? this.selectedProvider : this.selectedProvider.providerCode) {
      for (let provider of this.selectedProvider) {
        const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
        Obj_AppointmentTimeSlotModel.providerCode = provider.providerCode;//this.appointmentForm.get('provider')?.value;
        Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
        Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
        Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
        Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
        Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
        Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
        Obj_AppointmentTimeSlotModel.date = this.appointmentDate;
        Obj_AppointmentTimeSlotModel.isTelehealth = this.appointment_type == 'office' ? false : true;
        const check = await this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel);
        if (check) {
          const slots = this.appointmentSlots;
          if (Array.isArray(slots) && slots.length > 0) {
            slots.forEach((slot: any) => {
              slot.providerName = provider.providerName;
              slot.providerCode = provider.providerCode;
            });
            allSlots.push(...slots);
            foundAtLeastOneSlot = true;
          }
        }
      }
      if (foundAtLeastOneSlot && allSlots.length > 0) {
        this.groupedSlots = this.groupSlotsByDate(allSlots);
        this.updateGroupedSlotsArray();
        this.appointmentSlots = allSlots;
        this.appointmentTimeSlotFlag = true;
        this.updateGroupedSlotsArray();
        this.ShowSlotsScreens = true;
      } else {
        this.appointmentTimeSlotFlag = false;
        this.ShowSlotsScreens = true;
      }
    }
    this.spinner.hide('timeslots');
  }
  updateGroupedSlotsArray() {
    this.groupedSlotsArray = Object.entries(this.groupedSlots).map(([date, providers]) => ({
      date,
      providers
    }));
  }
  groupSlotsByDate(slots: any[]): { [key: string]: { providerName: string; slots: any[] }[] } {
    ////console.log('Grouping slots by date. Total slots:', slots);
    const validDates = this.dSeriesFinal.map((dateObj: any) =>
      this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
    );

    const filteredSlots = slots.filter(slot =>
      validDates.includes(this.datepipe.transform(new Date(slot.availableDate), 'MM/dd/yyyy'))
    );
    ////console.log('Filtered slots based on valid dates:', filteredSlots);
    const slotSource = this.isFirstAvailable ? slots : filteredSlots;
    ////console.log('Filtered slots for grouping:', slotSource);
    const groupedByDate: { [key: string]: { providerName: string; slots: any[] }[] } = {};

    for (const slot of slotSource) {
      const date = this.datepipe.transform(new Date(slot.availableDate), 'MM/dd/yyyy');
      const providerName = slot.providerName;

      if (!date) continue;

      if (!groupedByDate[date]) {
        groupedByDate[date] = [];
      }

      let providerGroup = groupedByDate[date].find(p => p.providerName === providerName);

      if (!providerGroup) {
        providerGroup = { providerName, slots: [] };
        groupedByDate[date].push(providerGroup);
      }

      providerGroup.slots.push(slot);
    }

    ////console.log('Grouped slots by date:', groupedByDate);
    return groupedByDate;
  }
  trackBySlot(index: number, slot: any): string {
    return slot.availableSlot + '_' + slot.availableDate;
  }
  convertToDateFormat(dateStr: string): string {
    const [month, day, year] = dateStr.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  async SelectPatientOption(selectedOption: any) {
    this.availableDate = localStorage.getItem('selectedSlotavailableDate');
    this.availableSlot = localStorage.getItem('selectedSlotavailableSlot');
    this.currentTimeZoneOffSet = localStorage.getItem('currentTimeZoneOffSet');
    this.appointmentForm.markAllAsTouched();
    if (!this.appointmentForm.invalid && this.selectedSlot.availableSlot && this.selectedSlot.availableDate) {
      this.patientpersonalinfo.type = selectedOption;
      this.patientpersonalinfo.patientAccount = localStorage.getItem('patientAccount');
      let data = this._phrutilService.encrypt(this.patientpersonalinfo);
      localStorage.setItem('PatientInfo', data);
      if (selectedOption == 'check-in') {
        this._router.navigateByUrl('/securelogin');
      }
      else if (selectedOption == 'walkin') {
        localStorage.setItem('rescheduleProvider', JSON.stringify(this.selectedProvider));
        if (this.isDirectUrlMode) {
          let Obj_reschedulePatientAppointModel = new reschedulePatientAppointModel();
          Obj_reschedulePatientAppointModel.appointment_Id = this.patientpersonalinfo.APPOINTMENT_ID
          Obj_reschedulePatientAppointModel.provider_Code = this.provider
          Obj_reschedulePatientAppointModel.location_Id = this.Location
          Obj_reschedulePatientAppointModel.reason_Id = this.reason
          Obj_reschedulePatientAppointModel.practice_Code = this.Practice_code;
          Obj_reschedulePatientAppointModel.patient_Account = this.patientpersonalinfo.PATIENT_ACCOUNT
          Obj_reschedulePatientAppointModel.patTimeZone = this.currentTimeZoneOffSet
          Obj_reschedulePatientAppointModel.appointment_Date = this.availableDate
          Obj_reschedulePatientAppointModel.time_From = this.availableSlot.replace(/"/g, '').trim();
          this.spinner.show();
          this.appoint.ReschedulePatientAppointments(Obj_reschedulePatientAppointModel).subscribe((res: any) => {
            if (res && res.data.isAppointmentRescheduled.toLowerCase() == "success") {
              this.spinner.hide();
              let text = "Appointment has been rescheduled successfully";
              this.translateService.get('Alerts.appointment_resech_successfull').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showSuccess(text);
              this._router.navigate(['/appoin-mes'])
            } else {
              this.spinner.hide();
              let text = "Service is not available, please try later.";
              this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showError(text);
            }
          }, (error: any) => {
            //console.log(error);
            this.spinner.hide();
            let text = "Service is not available, please try later.";
            $("#linkexpire-model").modal("show");
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
          })

        }
        else {
          if (this.isFromCancel) {
            this.onAddScheduleAppointment();
          }
          else if (this.isFromNewPatient) {
            this.onAddScheduleAppointment();
          }
          else {
            if (this.isWaitlist) {
              $("#waitlistModal").modal("hide");
            }
            this._router.navigate(['/securelogin'], { queryParams: { 'type': 'appointment', isFirstAvail: this.isFirstAvailable } });
          }
        }
      }
      else if (selectedOption == 'payment') {
        this._router.navigate(['/securelogin'], { queryParams: { 'type': 'payment' } });
      }

    }

    else {
      if (!this.appointmentForm.invalid && this.availableSlot == null && this.availableDate == null) {
        let text = "Please select appointment slot first.";
        this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
      }
      return;
    }
  }
  async VerifyPractice(practice_code: any): Promise<void> {
    this.spinner.show();
    try {
      const res: any = await this._registor.VerifyPracticeCode(practice_code).toPromise();
      this.spinner.hide();
      if (res.data && res.statusCode == 200) {
        this.patientpersonalinfo = res.data;
        this.patientpersonalinfo.practice_name = res.data.prac_Name;
        this.patientpersonalinfo.practice_code = res.data.practice_Code;
        this.Practice_code = this.patientpersonalinfo.practice_code;
        let data = this._phrutilService.encrypt(this.patientpersonalinfo);
        localStorage.setItem('PatientInfo', data);
        if (this.encounterId != null && this.landfrom == 'checkoutnotes') {
          await this.VerifyEncounter(this.Practice_code, this.encounterId);
        }
        const landfrom = localStorage.getItem("landFrom");
        localStorage.setItem('pracName', this.patientpersonalinfo.practice_name);
        this._phrutilService.setNavpracName(this.patientpersonalinfo.practice_name);
      } else {
        $("#isNotValid_linkexiting").modal("show");
        throw new Error('Invalid practice code');
      }
    } catch (error) {
      this.spinner.hide();
      $("#isNotValid_linkexiting").modal("show");
      throw error;
    }
  }
  onChangeProvider() {
    this.scheduleAppointmentModel = [];
    this.appointmentTimeSlotFlag = true;
    const providerValue = this.appointmentForm.get('provider')?.value;
    if (providerValue) {
      this.selectedProvider = {
        providerCode: providerValue,
        providerName: this.getProviderName(providerValue)
      };
      //console.log("selected provider in onchange Provider");
      localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
    }
    this.getAppointmentTimeSlot();
  }
  onChangeDate(type: any, event?: any) {
    //console.log("onChangeDate called", type, event);
    if (type === 'selectall' && this.is100Prac) {
      this.selectedProvider = event;   // all providers array
      this.filterSpecialityReason(this.selectedProvider);
    } else if (type == 'select' && this.is100Prac){
      this.selectedProvider = this.appointmentForm.get('provider')?.value;
      this.filterSpecialityReason(this.selectedProvider);
    }
    if (type === 'deselectall' && this.is100Prac) {
      console.log("deselect all");
      this.filterSpecialityReason(this.selectedProvider);
      return
    }
    
   // console.log("onChangeDate called",type);
    //onsole.log("Practice_code", this.Practice_code);
    const providerValue = this.appointmentForm.get('provider')?.value;
    this.selectedProvider = this.appointmentForm.get('provider')?.value;

    // if (providerValue) {
    //   this.selectedProvider = {
    //     providerCode: providerValue,
    //     providerName: this.getProviderName(providerValue)
    //   };
    //   localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
    // }
    // console.log(this.selectedProvider,"selected provider in change date");
  
   // console.log("selected provider in onchnagedate");
    localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
    const locationValue = this.appointmentForm.get('location')?.value;
    if (locationValue) {
      this.selectedLocation = {
        locationCode: locationValue,
        locationName: this.getLocationName(locationValue)
      };
      localStorage.setItem('selectedLocation', JSON.stringify(this.selectedLocation));
    }

    //console.log("selectedReason", this.selectedReason);

    const appointmentTypeValue = this.appointmentForm.get('appointmenttype')?.value;
    if (providerValue && locationValue && this.reasonValue && appointmentTypeValue !== '' && appointmentTypeValue !== null) {
      const SelectedValues = {
        provider: { providerCode: providerValue, providerName: this.getProviderName(providerValue) },
        location: locationValue ? { id: locationValue, name: this.getLocationName(locationValue) } : null,
        reason: this.reasonValue ? { id: this.reasonValue, name: this.getReasonName(this.reasonValue) } : null
      };
      this.provider = this.provider
      this.Location = locationValue;
      this.reason = this.reasonValue;

      if (this.landFromCheckin == 'checkin_reschedule') {
        this.patientpersonalinfoCheckin.providerCode = providerValue;
        this.patientpersonalinfoCheckin.appointmentLocation = locationValue;
        this.patientpersonalinfoCheckin.reason_Id = this.reasonValue;
        let data = this._phrutilService.encrypt(this.patientpersonalinfoCheckin);
        localStorage.setItem('PatientInfoCheckin', data);
      }
      if (this.landfrom == "checkoutnotes" && this.patientpersonalinfo.recallDate) {
        ////console.log("checkoutnotes");
        this.minDate = this.patientpersonalinfo.recallDate;
        this.minimumDate = new Date(this.patientpersonalinfo.recallDate)
        this.minDateFull = this.minDate ?? "";
        this.selectedDateApp = this.minDateFull;
        this.availableDate = this.patientpersonalinfo.recallDate;
        //console.log("recallDate in onChangeDate", this.patientpersonalinfo.recallDate);
        this.setAppointmentDates(this.patientpersonalinfo.recallDate);
      }

      this._phrutilService.updateDropdownValues(SelectedValues);
      localStorage.setItem('selectedValues', JSON.stringify(SelectedValues));
      ////console.log('Form values changed, fetching new appointment slots:', localStorage.getItem('selectedValues'));
      ////console.log('Selected appointment date before fetching slots:', this.appointmentForm.value);
      if (this.landfrom == "checkoutnotes" && this.patientpersonalinfo.recallDate) {
        this.isFirstAvailable = true;
        this.isFirstAvailibleButton = true;
      }
      else {
        this.isFirstAvailable = false;
      }
      this.getAppointmentTimeSlot();
    }
    else {
      return;
    }
  }
  // loadDatesForSelectedMonth(month: number, year: number) {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

  //   if (this.isMonthChanged) {
  //     this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
  //       const newDate = new Date(year, month - 1, +dateObj.date);
  //       const day = newDate.getDay();
  //       const dayNameData = this.dayNames.find((x: any) => Number(x.id) === day);
  //       const dayName = dayNameData?.Day || 'Unknown';

  //       const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
  //         m.id == (month).toString())?.Month || '';
  //       newDate.setHours(0, 0, 0, 0);
  //       const isDisable = newDate.getTime() < today.getTime();
  //       //const isDisable = newDate < today; // Disable dates in the past
  //       return {
  //         ...dateObj,
  //         fullDate: `${month}/${dateObj.date}/${year}`,
  //         day: dayName,
  //         month: monthName,
  //         isDisable: isDisable, // Mark as disabled if the date is in the past
  //       };
  //     });

  //     this.selectedMonthName = `${this.monthNames.find((m: { id: string; Month: string }) =>
  //       m.id == (month).toString())?.Month || ''} ${year}`;
  //     const selectedDates: string[] = this.dSeriesFinal
  //       .filter((d: any) => d.isSelected)
  //       .map((d: any) => d.fullDate);
  //     this.appointmentDate = this.dSeriesFinal[0].fullDate;
  //     this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
  //     this.firstAvailabeSelectedDate = this.dSeriesFinal[0].fullDate;
  //     this.isFirstAvailable = false;

  //     this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
  //       dateObj.isSelected = false;
  //       return dateObj;
  //     });
  //     this.getAppointmentTimeSlot().then(() => {
  //       this.cdr.detectChanges();
  //     });
  //   } else {
  //     this.dSeriesFinal = [];
  //     let date = new Date(year, month - 1, 1);
  //     let count = 0;
  //     while (count < 5) {
  //       const day = date.getDay();
  //       const dayNameData = this.dayNames.find((x: any) => Number(x.id) === day);
  //       if (dayNameData.Day !== 'Sat' && dayNameData.Day !== 'Sun') {
  //         const dateDigit = date.getDate();
  //         const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
  //           m.id == (date.getMonth() + 1).toString())?.Month || '';

  //         const isDisable = date < today; // Disable dates in the past

  //         this.dSeriesFinal.push({
  //           fullDate: `${date.getMonth() + 1}/${dateDigit}/${date.getFullYear()}`,
  //           date: dateDigit,
  //           day: dayNameData?.Day || 'Unknown',
  //           month: monthName,
  //           isDisable: isDisable, // Mark as disabled if the date is in the past
  //           isSelected: false,
  //         });
  //         count++;
  //       }
  //       date.setDate(date.getDate() + 1);
  //     }

  //     if (!this.isFirstAvailable) {
  //       this.appointmentDate = this.dSeriesFinal[0].fullDate;
  //       this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
  //       this.firstAvailabeSelectedDate = this.dSeriesFinal[0].fullDate;
  //     }

  //     this.selectedMonthName = `${this.monthNames.find((m: { id: string; Month: string }) =>
  //       m.id == (month).toString())?.Month || ''} ${year}`;
  //   }
  // }

  reasonValue: any;

  onchangeReason() {

    this.reasonValue = this.appointmentForm.get('reason')?.value;
    //console.log("reasonValue", this.reasonValue);

    if (!this.reasonValue) return;

    this.selectedReason = {
      reasonId: this.reasonValue,
      reasonName: this.getReasonName(this.reasonValue)
    };
    if (this.is100Prac) {
      const providerMatches = this.allReasonsData?.providerSpecialtyReasons
        ?.filter((p: any) =>
          p.reasons?.some((r: any) => r.reasonId === this.selectedReason.reasonId)
        );

      if (providerMatches?.length) {

        const providerCodes = providerMatches.map((p: any) => p.providerCode);

        // filter providers
        this.selectedProvider = this.providerData.filter((p: any) =>
          providerCodes.includes(p.providerCode)
        );

       // console.log("speciality provider", this.selectedProvider);
        this.appointmentForm.get('provider')?.setValue(this.selectedProvider);

      } 

   
    }
 

    // special case
    if (
      this.Practice_code == '100' &&
      this.selectedReason?.reasonName?.toLowerCase() === "lab work only"
    ) {
      this.selectedReason = null;
      this.appointmentForm.get('reason')?.setValue(null);
      $("#noLabWorkModal").modal("show");
      return;
    }

    localStorage.setItem('selectedReason', JSON.stringify(this.selectedReason));

    this.onChangeDate("reason");
  }

  loadDatesForSelectedMonth(month: number, year: number) {
    //console.log('Loading dates for month:', month, 'year:', year);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (this.isMonthChanged) {

      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {

        const newDate = new Date(year, month - 1, +dateObj.date);
        newDate.setHours(0, 0, 0, 0); // 🔥 normalize

        const day = newDate.getDay();

        const dayNameData = this.dayNames.find(
          (x: any) => Number(x.id) === day
        );

        const dayName = dayNameData?.Day || 'Unknown';

        const monthName =
          this.monthNames.find(
            (m: any) => m.id == month.toString()
          )?.Month || '';

        const isDisable =
          newDate.getTime() < today.getTime(); // 🔥 safe compare

        return {
          ...dateObj,
          fullDate: `${month}/${dateObj.date}/${year}`,
          day: dayName,
          month: monthName,
          isDisable
        };
      });

      this.selectedMonthName =
        `${this.monthNames.find((m: any) =>
          m.id == month.toString())?.Month || ''} ${year}`;

      // Reset selection
      this.dSeriesFinal.forEach((d: { isSelected: boolean }) => d.isSelected = false);

      // Select first available
      const firstAvailable =
        this.dSeriesFinal.find((d: { isDisable: boolean }) => !d.isDisable);

      if (firstAvailable) {

        firstAvailable.isSelected = true;

        this.appointmentDate = firstAvailable.fullDate;
        this.selectedDateApp =
          this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');

        this.firstAvailabeSelectedDate =
          firstAvailable.fullDate;
      }

      this.getAppointmentTimeSlot().then(() => {
        this.cdr.detectChanges();
      });

    } else {

      this.dSeriesFinal = [];

      let date = new Date(year, month - 1, 1);
      let count = 0;

      while (count < 5) {

        date.setHours(0, 0, 0, 0); // 🔥 normalize

        const day = date.getDay();

        const dayNameData =
          this.dayNames.find((x: any) => Number(x.id) === day);

        if (dayNameData.Day !== 'Sat' && dayNameData.Day !== 'Sun') {

          const dateDigit = date.getDate();

          const monthName =
            this.monthNames.find((m: any) =>
              m.id == (date.getMonth() + 1).toString()
            )?.Month || '';

          const isDisable =
            date.getTime() < today.getTime(); // 🔥 safe compare

          this.dSeriesFinal.push({

            fullDate: `${date.getMonth() + 1}/${dateDigit}/${date.getFullYear()}`,
            date: dateDigit,
            day: dayNameData?.Day || 'Unknown',
            month: monthName,
            isDisable,
            isSelected: false
          });

          count++;
        }

        date.setDate(date.getDate() + 1);
      }

      // Select first enabled date
      const firstAvailable =
        this.dSeriesFinal.find((d: { isDisable: boolean }) => !d.isDisable);

      if (firstAvailable) {

        firstAvailable.isSelected = true;

        this.appointmentDate = firstAvailable.fullDate;

        this.selectedDateApp =
          this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');

        this.firstAvailabeSelectedDate =
          firstAvailable.fullDate;
      }

      this.selectedMonthName =
        `${this.monthNames.find((m: any) =>
          m.id == month.toString())?.Month || ''} ${year}`;
    }
  }
  updateCarouselDatesForNewMonth(selectedMonth: number, selectedYear: number): void {
    //console.log('Updating carousel dates for month:', selectedMonth, 'year:', selectedYear);
    const newDates: any[] = [];
    let count = 0;
    for (const dayNum of this.selectedDayNumbers) {
      const newDate = new Date(selectedYear, selectedMonth - 1, dayNum);
      const dayOfWeek = newDate.getDay();
      if (newDate.getMonth() + 1 === selectedMonth && dayOfWeek !== 0 && dayOfWeek !== 6) {
        const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
          m.id == (newDate.getMonth() + 1).toString())?.Month || '';

        newDates.push({
          fullDate: `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`,
          date: newDate.getDate(),
          day: this.dayNames.find((x: any) => Number(x.id) === dayOfWeek)?.Day || 'Unknown',
          month: monthName,
          isDisable: false,
          isSelected: true
        });

        count++;
      }

      if (count >= 5) break;
    }

    this.dSeriesFinal = newDates;
  }
  nextAppointmentDate() {
    if (!this.dSeriesFinal || this.dSeriesFinal.length === 0) {
      console.error('dSeriesFinal is empty. Cannot calculate next dates.');
      return;
    }
    let date = new Date(this.dSeriesFinal[this.dSeriesFinal.length - 1].fullDate);
    const newDates: { fullDate: string; date: number; day: string; month: string; isDisable: boolean }[] = [];
    let count = 0;
    while (count < 5) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day === 0) {
        continue;
      }
      const dateDigit = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      let dayName = this.dayNames.find((x: any) => Number(x.id) === day);
      const monthName = this.monthNames.find((m: { id: string; Month: string }) => parseInt(m.id) === month)?.Month || 'Unknown';
      this.selectedMonthName = `${monthName} ${year}`;
      //console.log(`Checking date: ${month}/${dateDigit}/${year} - Day: ${dayName.Day}`);
      //console.log('Checking month:', monthName);
      if (dayName.Day !== 'Sat' && dayName.Day !== 'Sun') {
        newDates.push({
          fullDate: `${month}/${dateDigit}/${year}`,
          date: dateDigit,
          day: dayName.Day,
          month: monthName,
          isDisable: false,
        });
        count++;
      }
    }

    this.dSeriesFinal = newDates;
    localStorage.setItem('dSeriesFinal', this.dSeriesFinal[0].fullDate);
    //console.log('Updated dSeriesFinal with next dates:', this.dSeriesFinal);
    const validDates = this.dSeriesFinal.map((dateObj: any) =>
      this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
    );
    if (this.selectedSlot != null) {
      if (this.selectedSlot.availableDate) {
        const isSelectedSlotsInRange = validDates.includes(this.datepipe.transform(new Date(this.selectedSlot.availableDate), 'MM/dd/yyyy'));
        isSelectedSlotsInRange ? '' : this.selectedSlot = '';
      }
    }
    this.appointmentDate = this.dSeriesFinal[0].fullDate;
    this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
    //console.log('New appointmentDate set to:', this.appointmentDate);
    //console.log('New selectedDateApp set to:', this.selectedDateApp);
    this.scheduleAppointmentModel = [];
    if (this.appointmentForm.get('provider')?.value.length > 0) {
      //console.log('Fetching appointment time slots for new dates...');
      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
        dateObj.isSelected = false;
        return dateObj;
      });
      this.getAppointmentTimeSlot().then(() => {
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
          ...dateObj,
          isSelected: false
        }));
        this.cdr.detectChanges();
      });
    }
  }
  previousAppointmentDate() {
    let date = new Date(this.dSeriesFinal[0].fullDate);
    //let recalDate = this.patientpersonalinfo.recallDate ? new Date(this.patientpersonalinfo.recallDate) : null;
    ////console.log('Calculating previous dates from:', date);
    const newDates: { fullDate: string; date: number; day: string; month: string; isDisable: boolean }[] = [];
    let count = 0;

    const today = this.patientpersonalinfo.recallDate ? new Date(this.patientpersonalinfo.recallDate) : new Date();
    ////console.log('Today or recall date is:', today);
    today.setHours(0, 0, 0, 0);

    while (count < 5) {
      date.setDate(date.getDate() - 1);
      const compareDate = new Date(date);
      compareDate.setHours(0, 0, 0, 0);

      if (compareDate < today) {
        break;
      }

      const day = date.getDay();
      if (day === 0) continue;

      const dateDigit = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      const dayName = this.dayNames.find((x: any) => Number(x.id) === day);
      const monthName = this.monthNames.find((m: { id: string; Month: string }) => parseInt(m.id) === month)?.Month || 'Unknown';

      if (dayName.Day !== 'Sat' && dayName.Day !== 'Sun') {
        newDates.push({
          fullDate: `${month}/${dateDigit}/${year}`,
          date: dateDigit,
          day: dayName.Day,
          month: monthName,
          isDisable: false,
        });

        count++;
      }
    }

    if (newDates.length === 0) {
      //console.warn('No previous valid dates found.');
      return;
    }

    this.dSeriesFinal = newDates.reverse();
    //console.log('Updated dSeriesFinal with previous dates:', this.dSeriesFinal);
    localStorage.setItem('dSeriesFinal', this.dSeriesFinal[0].fullDate);
    const validDates = this.dSeriesFinal.map((dateObj: any) =>
      this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
    );

    if (this.selectedSlot?.availableDate) {
      const isSelectedSlotsInRange = validDates.includes(
        this.datepipe.transform(new Date(this.selectedSlot.availableDate), 'MM/dd/yyyy')
      );
      if (!isSelectedSlotsInRange) this.selectedSlot = '';
    }
    this.appointmentDate = this.dSeriesFinal[0].fullDate;
    this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
    this.scheduleAppointmentModel = [];
    if (this.appointmentForm.get('provider')?.value.length > 0) {
      //this.getAppointmentTimeSlot();
      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
        dateObj.isSelected = false;
        return dateObj;
      });
      this.getAppointmentTimeSlot().then(() => {
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
          ...dateObj,
          isSelected: false
        }));
        this.cdr.detectChanges();
      });
    }
  }
  // setAppointmentDates(newDate: Date) {
  //   try {
  //     ////console.log('Setting appointment dates starting from:', newDate);
  //     let date = new Date(newDate);
  //     let count = 0;
  //     const dSeries: any[] = [];
  //     const preservedDayNumbers = this.selectedDayNumbers || [];
  //     for (let i = 0; i <= 6; i++) {
  //       const year = date.getFullYear();
  //       const month = date.getMonth() + 1;
  //       const dateDigit = date.getDate();
  //       const day = date.getDay();
  //       const dayNameData = this.dayNames.find((x: any) => Number(x.id) === day);
  //       const dayName = dayNameData?.Day || 'Unknown';
  //       const monthNameData = this.monthNames.find((x: any) => Number(x.id) === month);
  //       const monthName = monthNameData?.Month || 'Unknown';
  //       this.selectedMonthName = `${monthName} ${year}`;
  //       if (day !== 0 && day !== 6 && count < 6) {
  //         count++;
  //         const isSelected = preservedDayNumbers.includes(dateDigit);
  //         dSeries.push({
  //           fullDate: `${month}/${dateDigit}/${year}`,
  //           date: `${dateDigit}`,
  //           day: dayName,
  //           month: monthName,
  //           isDisable: false,
  //           isSelected
  //         });
  //       }

  //       date.setDate(date.getDate() + 1);
  //     }

  //     if (dSeries.length === 0) {
  //       //console.error('dSeriesFinal is empty. Cannot proceed.');
  //       return;
  //     }

  //     this.dSeriesFinal = dSeries;
  //     //////console.log('Updated dSeriesFinal in setAppointmentDates:', this.dSeriesFinal);
  //     this.selectedDayNumbers = this.dSeriesFinal
  //       .filter((d: any) => d.isSelected)
  //       .map((d: any) => +d.date);
  //     if (this.dSeriesFinal.length > 0) {
  //       this.appointmentDate = this.dSeriesFinal[0].fullDate;
  //     }
  //     const first = this.dSeriesFinal.at(0);
  //     const last = this.dSeriesFinal.at(-1);
  //     this.dSeriesFinalFirstAndLast = [first, last];
  //   } catch (error) {
  //     this.OnTrackError(`setAppointmentDates`, error);
  //   }
  // }
  getMonday(date: Date): Date {
    const d = new Date(date);
    //console.log('Calculating Monday for date:', d);
    const day = d.getDay();
    //console.log('Day of week (0=Sun, 1=Mon, ..., 6=Sat):', day);
    // If Sunday (0), go back 6 days, else go back (day - 1)
    const diff = day === 0 ? -6 : 1 - day;
    //console.log('Difference in days to Monday:', diff);
    d.setDate(d.getDate() + diff);
    //console.log('Calculated Monday date for d:', d);
    return d;
  }
  setAppointmentDates(newDate: Date) {
    try {

      //console.log('Setting appointment dates from Monday');
      //console.log('Input date:', newDate);
      // 🔥 Normalize today (important)
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let date = this.getMonday(newDate);

      const dSeries: any[] = [];
      const preservedDayNumbers = this.selectedDayNumbers || [];

      let count = 0;

      for (let i = 0; i <= 6; i++) {

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const dateDigit = date.getDate();
        const day = date.getDay();

        const dayName =
          this.dayNames.find((x: any) => Number(x.id) === day)?.Day || 'Unknown';

        const monthName =
          this.monthNames.find((x: any) => Number(x.id) === month)?.Month || 'Unknown';

        this.selectedMonthName = `${monthName} ${year}`;

        // Skip weekends
        if (day !== 0 && day !== 6 && count < 6) {

          count++;

          // 🔥 Build item date
          const itemDate = new Date(year, month - 1, dateDigit);
          itemDate.setHours(0, 0, 0, 0);

          // 🔥 Disable if past
          const isDisable = itemDate.getTime() < today.getTime();

          const isSelected = preservedDayNumbers.includes(dateDigit);
          //console.log('Selected', dateDigit)
          dSeries.push({
            fullDate: `${month}/${dateDigit}/${year}`,
            date: `${dateDigit}`,
            day: dayName,
            month: monthName,
            isSelected: false,
            isDisable,
          });
        }

        // Next day
        date.setDate(date.getDate() + 1);
      }

      if (!dSeries.length) return;

      this.dSeriesFinal = dSeries;

      //console.log('Updated dSeriesFinal:', this.dSeriesFinal);

      // 🔥 Reset selection
      this.dSeriesFinal.forEach((d: { isSelected: boolean }) => d.isSelected = false);

      // 🔥 Select first ENABLED date
      const firstAvailable =
        this.dSeriesFinal.find((d: { isDisable: boolean }) => !d.isDisable);

      if (firstAvailable) {

        firstAvailable.isSelected = false;

        this.appointmentDate = firstAvailable.fullDate;

        this.selectedDateApp =
          this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
      }

      const first = this.dSeriesFinal.at(0);
      const last = this.dSeriesFinal.at(-1);

      this.dSeriesFinalFirstAndLast = [first, last];

    } catch (error) {

      this.OnTrackError(`setAppointmentDates`, error);

    }
  }
  updateMonthDisplay(date: Date) {
    //////console.log('Updating month display for date:', date);
    let currentMonthIndex = date.getMonth();
    let currentYear = date.getFullYear();

    let lastDayOfMonth = new Date(currentYear, currentMonthIndex + 1, 0).getDate();

    if (date.getDate() === lastDayOfMonth) {
      let newDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      this.loadDatesForSelectedMonth(newDate.getMonth() + 1, newDate.getFullYear());
      return;
    }

    this.selectedYear = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    this.selectedMonthName = this.monthNames.find((m: { id: string; Month: string }) =>
      m.id == month.toString())?.Month || '';
    this.loadDatesForSelectedMonth(parseInt(month), this.selectedYear);
    ////console.log('Updated month display to:', this.selectedMonthName, this.selectedYear);
  }
  getMonthName(monthIndex: number): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[monthIndex - 1];
  }
  formatSlotDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datepipe.transform(date, 'EEE, MMM dd') || '';
  }
  chosenMonthHandler(event: Date, datepicker: any) {
    datepicker.close();
    this.isMonthChanged = true
    this.selectedMonthCalander = event.getMonth() + 1;
    this.selectedYearCalander = event.getFullYear();
    this.appointmentDate = '';
    this.selectedDateApp = null;
    this.loadDatesForSelectedMonth(this.selectedMonthCalander, this.selectedYearCalander);
    this.selectedSlot = null;
    this.cdr.detectChanges();
  }
  reset() {
    this.appointmentForm.reset();
    this.buildappointmentForm();
  }
  get getappointmentForm() {
    return this.appointmentForm.controls;
  }
  formatDateForInput(dateString: string): string {
    if (!dateString) return "";
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const [month, day, year] = parts.map(Number);
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    }
    return new Date(dateString).toISOString().split('T')[0];
  }
  onDatePickerOpen() {
    if (!this.selectedDateApp) {
      this.selectedDateApp = this.minDateFull;
    }

    this.cdr.detectChanges();
  }
  ChangeSkipPayment(event: any) {

    if (event.target.checked) {
      this.isSkipPayment = true;
    }
    else {
      this.isSkipPayment = false;
    }
  }
  onAppointmentTimeSlot(selectedTimeSlot: appointmentTimeSlotModel, selectedScheduleAppointmentModel: scheduleAppointmentModel) {
    this.isSkipPayment = false;
    this.hardwareError = false;
    this.isAgree = false;
    $("#PaymentOption").prop("checked", false);
    this.selectedAppointmentTimeSlot = selectedTimeSlot;
    this.selectedAppointmentTimeSlot.isInsurance = selectedScheduleAppointmentModel.isInsurance;
    this.selectedAppointmentTimeSlot.appointmentCharges = selectedScheduleAppointmentModel.appointmentCharges;
    this.selectedAppointmentTimeSlot.appointmentChargesWithSign = `$ ${selectedScheduleAppointmentModel.appointmentCharges}`;
  }
  setCurrentMonth() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    this.selectedMonthName = `${this.getMonthName(month)} ${year}`;
  }
  openMonthPicker(picker: MatDatepicker<any>) {
    picker.open();
  }
  formatDateForPicker(dateString: string): string {
    let [month, day, year] = dateString.split('/').map(Number);
    let date = new Date(year, month - 1, day);
    let yyyy = date.getFullYear();
    let mm = String(date.getMonth() + 1).padStart(2, '0');
    let dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  updateCarouselDate(selectedDate: string) {
    if (!selectedDate) return;
    this.selectedDateApp = new Date(selectedDate);

    this.appointmentForm.patchValue({
      selectedDateApp: selectedDate
    });
    this.cdr.detectChanges();
  }
  async getProviders(): Promise<ProviderModel[]> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      this.appoint.GetProviderBreeze(this.Practice_code).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.data) {
            this.providerData = res.data.providers as ProviderModel[];
            this.landfrom = localStorage.getItem("landFrom");
            if (this.providerData && this.landfrom == 'checkoutnotes') {
              if (this.patientpersonalinfo.provider_code) {
                const providerValue = this.providerData.filter(provider =>
                  this.patientpersonalinfo.provider_code.includes(provider.providerCode)
                ).map(provider => ({
                  providerCode: provider.providerCode,
                  providerName: provider.providerName
                }));
                if (providerValue) {
                  // //console.log("provider value", providerValue);
                  this.selectedProvider = {
                    providerCode: providerValue[0].providerCode,
                    providerName: this.getProviderName(this.patientpersonalinfo.provider_code)
                  };
                 // if (this.is100Prac)
                  //this.filterSpecialityReason(this.selectedProvider);
                  this.appointmentForm.get('provider')?.setValue(providerValue);
                  //console.log("selected provider in get");
                  localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
                }
                this.onChangeDate('get provider');
              }

            } else {
              ////console.log('Fetched Providers:', this.providerData);
              if (this.providerData.length === 2) {
                setTimeout(() => {

                  this.appointmentForm.get('provider')?.setValue(this.providerData);
                  ////console.log('Auto-selected Providers:', this.appointmentForm.get('provider')?.value);
                });
              }
            }
            resolve(this.providerData);
            this.selectedProvider = this.providerData;
            ////console.log('Selected Provider after fetch:', this.selectedProvider);
          } else {
            this.providerData = [];
            resolve([]);
          }
        },
        (error: any) => {
          this.spinner.hide();
          this.providerData = [];
          reject(error);
        }
      );
    });
  }
  //async getAppointmentReason(): Promise<appointmentReasonModel[]> {
  //  this.appointmentReasonData = [];
  //  this.spinner.show();

  //  return new Promise((resolve, reject) => {
  //    this.appoint.AppointmentReasonsBreeze(this.Practice_code).subscribe(
  //      (res: any) => {
  //        this.spinner.hide();
  //        if (res.data && res.data.appoitnmentReasonsLists) {
  //          this.appointmentReasonData = res.data.appoitnmentReasonsLists as appointmentReasonModel[];
  //          this.appointmentReasonData = this.appointmentReasonData.filter((reason: any) => {
  //            const name = reason.reasonName.toLowerCase();
  //            return !name.includes('initial');
  //          });
  //          this.landfrom = localStorage.getItem("landFrom");
  //          if (this.appointmentReasonData && this.landfrom == 'checkoutnotes' && this.patientpersonalinfo.practice_code == "100") {
  //            const followUpId = "592";

  //            const followUp = this.appointmentReasonData.find((reason: any) => reason.reasonId === followUpId);
  //            if (followUp) {
  //              this.appointmentForm.get('reason')?.setValue(followUp.reasonId);
  //            }

  //          }
  //          resolve(this.appointmentReasonData);
  //          this.onChangeDate();
  //        } else {
  //          this.showServiceError();
  //          resolve([]);
  //        }
  //      },
  //      (error: any) => {
  //        this.spinner.hide();
  //        this.showServiceError();
  //        reject(error);
  //      }
  //    );
  //  });
  //}


  /*
  filterSpecialityReason(providerCodes?: any[]) {
   // console.log("selected provider", providerCodes);
    //const defaultReasons = this.appointmentReasonData ||[];
    const defaultReasons = this.allReasonsData?.appointmentReasonsLists || [];
    let specialityReasons: any[] = [];

    if (this.allReasonsData?.providerSpecialtyReasons?.length && providerCodes?.length) {

      const codes = providerCodes.map((p: any) => p.providerCode);

      const providerMatches = this.allReasonsData.providerSpecialtyReasons
        .filter((p: any) => codes.includes(p.providerCode));

      specialityReasons = providerMatches.flatMap((p: any) => p.reasons || []);
     // console.log(specialityReasons,"specialityReasons");
    }

    // combine common + speciality
    const combined = [...defaultReasons, ...specialityReasons];

    // remove empty + name check
    const validReasons = combined.filter((r: any) =>
      r?.reasonId && r?.reasonName?.trim()
    );

    // remove duplicates
    this.appointmentReasonData = Array.from(
      new Map(validReasons.map((r: any) => [r.reasonId, r])).values()
    ) as appointmentReasonModel[];
   // console.log(this.appointmentReasonData, " appointmentReasonData");
    this.reasonList = this.appointmentReasonData;
    console.log(this.selectedReason,"selectedReason");
    if (
      this.selectedReason &&
      !this.appointmentReasonData.some(
        (r: any) => r.reasonId === this.selectedReason.reasonId
      )
    ) {
      console.log("reason not in array");
      this.selectedReason = null;
      this.appointmentForm.get('reason')?.setValue('');
    }
    this.filterWellVisit(this.appointmenttype);

  }*/

  filterSpecialityReason(providerCodes?: any) {

    console.log("selected provider", providerCodes);

    let specialityReasons: any[] = [];

    if (this.allReasonsData?.providerSpecialtyReasons?.length && providerCodes?.length) {

      const codes = providerCodes.map((p: any) => p.providerCode);

      const providerMatches = this.allReasonsData.providerSpecialtyReasons
        .filter((p: any) => codes.includes(p.providerCode));

      specialityReasons = providerMatches.flatMap((p: any) => p.reasons || []);
       //console.log(specialityReasons,"specialityReasons");
    }

    //console.log(this.selectedReason, "selectedReason");

    if (this.selectedReason) {

      // check if selected reason is a speciality reason in system
      const isSpecialityReason = this.allReasonsData?.providerSpecialtyReasons
        ?.some((p: any) =>
          p.reasons?.some((r: any) => r.reasonId === this.selectedReason.reasonId)
        );

      // agar speciality reason hai aur selected provider usko support nahi karta
      if (
        isSpecialityReason &&
        !specialityReasons.some(
          (r: any) => r.reasonId === this.selectedReason.reasonId
        )
      ) {
        console.log("selected provider does not support this speciality reason");

        this.selectedReason = null;
        this.appointmentForm.get('reason')?.setValue(null);
      }
      if (
        providerCodes?.length > 1 &&
        this.selectedReason &&
        this.allReasonsData?.providerSpecialtyReasons?.some((p: any) =>
          p.reasons?.some((r: any) => r.reasonId === this.selectedReason.reasonId)
        )
      ) {
        console.log("multiple providers with speciality reason → reset reason");

        this.selectedReason = null;
        this.appointmentForm.get('reason')?.setValue(null);
      }
    }
  }
 
  allReasonsData: any;
  allReasons: any;
  filterWellVisit(type: any) {

    //console.log(type, "type");

    if (!this.allReasons) return;

    if (type === 'telehealth') {

      if (
        this.selectedReason &&
        (
          this.selectedReason.reasonName?.toLowerCase().includes('annual/well') ||
          this.selectedReason.reasonName?.toLowerCase().includes('well') ||
          this.selectedReason.reasonName?.toLowerCase().includes('injection')
        )
      ) {
        this.selectedReason = null;
        this.appointmentForm.get('reason')?.setValue('');
      }

      this.appointmentReasonData = this.allReasons.filter(
        (reason: any) =>
          !reason.reasonName.toLowerCase().includes('annual/well') &&
          !reason.reasonName.toLowerCase().includes('well') &&
          !reason.reasonName.toLowerCase().includes('injection')
      );

    } else {

      // office case → original list se rebuild
      this.appointmentReasonData = this.allReasons.filter(
        (reason: any) =>
          !reason.reasonName.toLowerCase().includes('injection')
      );

    }

  }

  async getAppointmentReason(): Promise<appointmentReasonModel[]> {
    this.appointmentReasonData = [];
    this.spinner.show();

    return new Promise((resolve, reject) => {
      this.appoint.AppointmentReasonsBreeze(this.Practice_code).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.data) {
            this.allReasonsData = res.data;
            //testing code
           /* this.allReasonsData.providerSpecialtyReasons = [
              {
                providerCode: "100",
                reasons: [
                  {
                    reasonId: "9999990000013",
                    reasonName: "Cardiology Consult",
                    providerCode: "100"
                  }
                ]
              },
              {
                providerCode: "55212287",
                reasons: [
                  {
                    reasonId: "9999990000014",
                    reasonName: "Urologist Consult",
                    providerCode: "55212287"
                  }
                ]
              }
            ];*/
            
            //testing code end
            if (this.allReasonsData.appointmentReasonsLists) {
              if (this.is100Prac) { 
              this.allReasonsData.appointmentReasonsLists = this.allReasonsData.appointmentReasonsLists.filter((reason: any) => {
                const name = reason.reasonName.toLowerCase();
                return !name.includes('initial');
              });
            }

              //this.appointmentReasonData = this.allReasonsData.appointmentReasonsLists as appointmentReasonModel[];
            
              if (this.is100Prac) {
                this.appointmentReasonData = [
                  ...(this.allReasonsData.appointmentReasonsLists || []),
                  ...(this.allReasonsData.providerSpecialtyReasons?.flatMap((p: any) => p.reasons) || [])
                ] as appointmentReasonModel[];
              } else {
                this.appointmentReasonData = this.allReasonsData.appointmentReasonsLists as appointmentReasonModel[];
              }
              this.allReasons = this.appointmentReasonData || []; // original
              this.landfrom = localStorage.getItem("landFrom");
              if (this.appointmentReasonData && this.landfrom == 'checkoutnotes' && this.patientpersonalinfo.practice_code == "100") {
                const followUpId = "592";

                const followUp = this.appointmentReasonData.find((reason: any) => reason.reasonId === followUpId);
                if (followUp) {
                  this.appointmentForm.get('reason')?.setValue(followUp.reasonId);
                }

              }
              resolve(this.appointmentReasonData);
              if (this.is100Prac) {
                this.filterWellVisit('office');
                this.onchangeReason();
              }
             
            }

          } else {
            console.log("0")
            this.showServiceError();
            resolve([]);
          }
        },
        (error: any) => {
          console.log("00")
          this.spinner.hide();
          this.showServiceError();
          reject(error);
        }
      );
    });
  }

  async getLocation(): Promise<LocationModel[]> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      this.appoint.GetLocationBreeze(this.Practice_code).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.data && res.data.locations.length !== 0) {
            let locationTemp = res.data.locations as LocationModel[];
            let filteredLocations = locationTemp.filter(data => data.locationName !== "");
            this.providerLocation = filteredLocations;
            if (this.providerLocation.length === 1 && !this.appointmentForm.get('location')?.value) {
              const onlyLocation = this.providerLocation[0];
              this.appointmentForm.get('location')?.setValue(onlyLocation.locationCode);
              this.Location = onlyLocation.locationCode;
            }

            resolve(this.providerLocation);
            this.onChangeDate('get location');
            ////console.log('Fetched Locations:', this.Location);
          } else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            resolve([]);
          }
        },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          reject(error);
        }
      );
    });
  }
  getProviderName(providerId: string): string {
    const providerName = this.providerList.find(p => p.providerCode === providerId);
    if (!providerName) {
      return 'Unknown Provider';
    }
    return providerName.providerName;
  }
  getLocationName(locationId: string): string {
    const location = this.locationList.find(l => l.locationCode === locationId);
    return location ? location.locationName : '';
  }
  getReasonName(reasonId: string): string {
   // console.log(reasonId,"reasonId");
    const reason = this.reasonList.find(r => r.reasonId === reasonId);
  //  console.log("get reason name",reason);
    return reason ? reason.reasonName : '';
  }
  onMonthChange(event: any) {
    this.selectedMonth = event;
    this.updateMonthDisplay(event);
  }
  OnTrackError(functionName: string, error: any) {
    //console.log(`Error Occured => ${functionName} (Appointments): ${error}`);
  }
  getObjectValues(obj: any): any[] {
    return Object.values(obj);
  }
  ngOnChanges() {
    this.updateGroupedSlotsArray();
  }
  waitlistGroupedSlotsArray(): void {
    this.waitlistSlotsArray = Object.entries(this.groupedSlotsWaitlist).map(([date, slots]) => ({ date, slots }));
    this.cdr.detectChanges();
  }
  onWaitListClick(date: string) {
    $("#waitlistModal").modal("show");
    this.onWaitList(date)
    $("#waitlistModal").modal("hide");
  }
  async onWaitList(waitlistDate: string) {
    this.Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
    this.spinner.show('timeslots');
    this.firstAvailableIstrue = true;
    this.Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
    this.Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
    this.Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
    this.Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
    this.Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
    this.Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
    this.Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
    this.Obj_AppointmentTimeSlotModel.isTelehealth = this.appointment_type == 'office' ? false : true;
    this.Obj_AppointmentTimeSlotModel.date = waitlistDate
    try {
      const res: any = await this.appoint.GetTimeSlotsForWaitList(this.Obj_AppointmentTimeSlotModel);
      if (res.statusCode == 200) {
        this.isFirstAvailable = false;
        this.isWaitlist = true;
        localStorage.setItem('isWaitlist', JSON.stringify(this.isWaitlist));
        const slots = res.data.appointmentSlots;
        this.groupedSlotsWaitlist = this.groupSlotsByDate(slots);
        this.appointmentSlots = slots;
        this.waitlistGroupedSlotsArray();
        if (this.appOBJ.appointmentSlots.length > 0) {
          this.appointmentTimeSlotFlag = true;
        } else {
          this.appointmentTimeSlotFlag = false;
        }
      }
      this.spinner.hide('timeslots');
    } catch (error) {
      this.OnTrackError(`getAppointmentTimeSlot`, error);
    }
    this.spinner.hide('timeslots');
  }
  trackByFn(index: number, group: any): string {
    return group.date;
  }
  onClickMore(groupIndex: number, providerIndex: number) {
    const key = `${groupIndex}-${providerIndex}`;
    this.expandedSlots[key] = !this.expandedSlots[key];
  }
  ConverttoLocalDate(date: any): Date {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;
    const formattedDate = moment(date, ['MM/DD/YYYY h:mm A', 'MM/DD/Y h:mm:ss A']).toDate();
    return formattedDate;
  }
  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }
  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }
  normalizeDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datepipe.transform(date, 'MM/d/yyyy') || '';
  }
  isSlotSelected(slot: any): boolean {
    return (
      this.selectedSlot &&
      this.selectedSlot.availableSlot === slot.availableSlot &&
      this.selectedSlot.availableDate === slot.availableDate
    );
  }
  updateCarouselDates(selectedDate: string) {
    //////console.log('Selected date for carousel update:', selectedDate);
    const normalizedSelectedDate = this.datepipe.transform(new Date(selectedDate), 'MM/d/yyyy');
    this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
      dateObj.isSelected = this.normalizeDate(dateObj.fullDate) === normalizedSelectedDate;
      return dateObj;
    });
    //////console.log('Updated dSeriesFinal after carousel date update:', this.dSeriesFinal);
    this.cdr.detectChanges();
  }
  // onSelectSlot(event: any, slot: any, WaitlistSlot: boolean) {
  //   //////console.log('dSeriesFinal before selecting slot:', this.dSeriesFinal);
  //   localStorage.setItem('dSeriesFinal', this.dSeriesFinal[0].fullDate);
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.selectedSlot = slot;
  //   this.isWaitlist = WaitlistSlot;
  //   Object.keys(this.groupedSlots).forEach(date => {
  //     this.groupedSlots[date].forEach((s: any) => {
  //       s.isSelected = s.availableSlot === slot.availableSlot && s.availableDate === slot.availableDate;
  //     });
  //   });
  //   localStorage.setItem('selectedSlotavailableSlot', JSON.stringify(slot.availableSlot));
  //   localStorage.setItem('selectedSlotavailableDate', slot.availableDate);
  //   localStorage.setItem('selectedProviderCode', JSON.stringify(slot.providerCode));
  //   localStorage.setItem('selectedProviderName', JSON.stringify(slot.providerName));
  //   this.selectedMonth = slot.availableDate
  // }
  onSelectSlot(event: any, slot: any, WaitlistSlot: boolean) {
    event.preventDefault();
    event.stopPropagation();

    this.selectedSlot = slot;
    this.isWaitlist = WaitlistSlot;

    // 🔹 Step 1: Clear all existing selections
    Object.keys(this.groupedSlots).forEach(date => {
      this.groupedSlots[date].forEach((provider: any) => {
        provider.slots.forEach((s: any) => {
          s.isSelected = false;
        });
      });
    });

    const selectedDate = this.datepipe.transform(new Date(slot.availableDate), 'MM/dd/yyyy');
    const providersForDate = this.groupedSlots[selectedDate];
    //console.log('Providers for selected date:', providersForDate);
    if (providersForDate) {
      providersForDate.forEach((provider: any) => {
        if (provider.providerCode === slot.providerCode) {
          const targetSlot = provider.slots.find(
            (s: any) =>
              s.availableSlot === slot.availableSlot &&
              s.availableDate === slot.availableDate
          );
          if (targetSlot) {
            targetSlot.isSelected = true; // Mark the correct slot as selected
          }
        }
      });
    }
    // 🔹 Step 3: Save selected info in localStorage
    localStorage.setItem('selectedSlotavailableSlot', JSON.stringify(slot.availableSlot));
    localStorage.setItem('selectedSlotavailableDate', slot.availableDate);
    localStorage.setItem('selectedProviderCode', JSON.stringify(slot.providerCode));
    localStorage.setItem('selectedProviderName', JSON.stringify(slot.providerName));

    this.selectedMonth = slot.availableDate;
  }
  backPage() {
    if (this.ShowSlotsScreens == true) {
      if (this.isDirectUrlMode == true) {
        let query = sessionStorage.getItem('AccessLink');
        if (query == null) {
          query = '';
        }
        this._router.navigateByUrl("patient/verifypatient?pa=" + query);
      }
      else {
        this.ShowSlotsScreens = false
        setTimeout(() => {
          const restoredSelectedValues = localStorage.getItem('selectedValues');
          const selectedValues = restoredSelectedValues ? JSON.parse(restoredSelectedValues) :
            { providerValue: '', locationValue: '', reasonValue: '' };
          const availableDate = localStorage.getItem('selectedSlotavailableDate') || '';
          this.appointmentForm.patchValue({
            provider: selectedValues.providerValue,
            appointmenttype: this.appointment_type,
            location: selectedValues.locationValue,
            reason: selectedValues.reasonValue,
          });
        }, 500);
      }
    }
    else if (this.isDirectUrlMode == false && this.ShowSlotsScreens == false && this.landFromCheckin == 'checkin_cancel') {
      let query = sessionStorage.getItem('AccessLink');
      if (query == null) {
        query = '';
      }
      this._router.navigateByUrl("patient/verifypatient?pa=" + query);
    }
    else {
      if (this.isDrsite)
        this._router.navigateByUrl("/scheduler?practice_code=" + this.Practice_code + "&lf=drsite");
    }
  }
  private showServiceError() {
    let text = "Service is not available, please try later.";
    this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
      text = translation;
    });
    this._phrutilService.showError(text);
  }
  onAddScheduleAppointment() {
    this.appointmentForm.markAllAsTouched();
    if (!this.appointmentForm.invalid && this.selectedSlot.availableSlot && this.selectedSlot.availableDate) {
      let Obj_addScheduleAppointmentModel = new addAppointmentRequest();
      Obj_addScheduleAppointmentModel.first_Name = this.isFromNewPatient ? this.patientpersonalinfo.first_Name : this.patientpersonalinfoCheckin.firstName;
      Obj_addScheduleAppointmentModel.last_Name = this.isFromNewPatient ? this.patientpersonalinfo.last_Name : this.patientpersonalinfoCheckin.lastName;
      Obj_addScheduleAppointmentModel.dateofBrith = this.isFromNewPatient ? this.patientpersonalinfo.date_Of_Birth : this.patientpersonalinfoCheckin.dateOfBirth;
      Obj_addScheduleAppointmentModel.email = this.isFromNewPatient ? this.patientpersonalinfo.email_Address : (this.patientpersonalinfoCheckin.emailAddress ? this.patientpersonalinfoCheckin.emailAddress : this.patientpersonalinfoCheckin.cellPhone);
      Obj_addScheduleAppointmentModel.phone = this.isFromNewPatient ? this.patientpersonalinfo.cell_phone : this.patientpersonalinfoCheckin.cellPhone;
      Obj_addScheduleAppointmentModel.app_ReasonId = this.appointmentForm.get('reason')?.value;
      Obj_addScheduleAppointmentModel.location_Code = this.appointmentForm.get('location')?.value
      Obj_addScheduleAppointmentModel.provider_Code = this.appointmentForm.get('provider')?.value;
      Obj_addScheduleAppointmentModel.practice_code = this.isFromNewPatient ? this.patientpersonalinfo.practice_Code : this.patientpersonalinfoCheckin.practiceCode;
      Obj_addScheduleAppointmentModel.patient_Account = this.isFromNewPatient ? this.patientpersonalinfo.patient_Account : this.patientpersonalinfoCheckin.patientAccount;
      Obj_addScheduleAppointmentModel.teleMedicine_Session = this.appointment_type == 'office' ? '0' : '1';
      Obj_addScheduleAppointmentModel.app_date = this.selectedSlot.availableDate;
      Obj_addScheduleAppointmentModel.client_IP = sessionStorage.getItem('IP') ? sessionStorage.getItem('IP') : '';
      Obj_addScheduleAppointmentModel.patTimeZone = this.currentTimeZoneOffSet;
      Obj_addScheduleAppointmentModel.time_From = this.selectedSlot.availableSlot;
      Obj_addScheduleAppointmentModel.isConsentForm = '0';
      Obj_addScheduleAppointmentModel.appSource = 'Drsite';
      this.spinner.show();
      this.appoint.addScheduleAppointment(Obj_addScheduleAppointmentModel).subscribe((res: any) => {
        this.spinner.hide();

        if (res.message.toLowerCase() == "success" && res.statusCode == 200) {
          if (res.data.isAppointmentInserted.toLowerCase() == "true") {
            let text = this.landFromCheckin === 'checkin_reschedule' || this.landFromCheckin == 'checkin_cancel'
              ? 'Alerts.appointment_resech_successfull'
              : 'Alerts.appointment_successfull';
            this.translateService.get(text).subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            this.patientpersonalinfo.appointmentid = res.data.appointmentId;
            let data = this._phrutilService.encrypt(this.patientpersonalinfo);
            localStorage.setItem('PersonalInfo', data);
            if (this.isFromNewPatient) {
              localStorage.setItem('PatientInfo', data);
              this._router.navigateByUrl('/pay_type');
            }
            else {
              this._router.navigateByUrl('/appoin-mes');
            }
          } else {
            if (res.data.finalMessage === "You already have an appointment for this day. In case of any issue please contact provider office.") {
              this.translateService.get('Appointment.appointment_already_exist_for_the_day').subscribe((translation: string) => {
                let text = translation;
                this._phrutilService.showInfo(text);
              });

            } else if (res.data.finalMessage === "You can make only one appointment in 14 days. In case of any issue please contact provider office.") {
              this.translateService.get('Appointment.appointment_14_day_check').subscribe((translation: string) => {
                let text = translation;
                this._phrutilService.showInfo(text);
              });
            }
            else {
              this._phrutilService.showInfo(res.data.finalMessage);
            }
          }
        } else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        }
      },
        (error: any) => {
          this.spinner.hide(); let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        });
    }
    else {
      if (!this.appointmentForm.invalid && !this.selectedSlot.availableSlot && !this.selectedSlot.availableDate) {
        let text = "Please select appointment slot first.";
        this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);

      }
      return;
    }
  }
}


